var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2586 2.9991C7.16857 2.8591 2.99857 6.9491 2.99857 11.9991H1.20857C0.758566 11.9991 0.538566 12.5391 0.858566 12.8491L3.64857 15.6391C3.84857 15.8391 4.15857 15.8391 4.35857 15.6391L7.14857 12.8491C7.21767 12.7786 7.26436 12.6892 7.28275 12.5922C7.30114 12.4953 7.29041 12.395 7.25191 12.3041C7.21341 12.2132 7.14887 12.1357 7.06641 12.0814C6.98396 12.0272 6.88728 11.9985 6.78857 11.9991H4.99857C4.99857 8.0991 8.17857 4.9491 12.0986 4.9991C15.8186 5.0491 18.9486 8.1791 18.9986 11.8991C19.0486 15.8091 15.8986 18.9991 11.9986 18.9991C10.7486 18.9991 9.57857 18.6591 8.55857 18.0891C8.36987 17.9836 8.15139 17.944 7.93768 17.9766C7.72397 18.0092 7.52723 18.1121 7.37857 18.2691C6.91857 18.7291 7.00857 19.5191 7.57857 19.8391C8.88857 20.5691 10.3886 20.9991 11.9986 20.9991C17.0486 20.9991 21.1386 16.8291 20.9986 11.7391C20.8686 7.0491 16.9486 3.1291 12.2586 2.9991Z",
    fill: "#00205A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.4995L12 13.4995V7.99951",
    stroke: "#00205A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d563ff461d30a0241d3bfae82e37cd74.svg";
export { ForwardRef as ReactComponent };